exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check[data-v-438d904e]{margin-bottom:10px}.card[data-v-438d904e]{border-radius:var(--mozali-radius-lg);box-shadow:var(--mozali-shadow-card);border:1px solid var(--default-border-color)}.btn-lg[data-v-438d904e]{padding:12px 30px;font-size:16px}.reports-submit-btn[data-v-438d904e]:hover{transform:scale(1.04);box-shadow:var(--mozali-shadow-cta)}@media (prefers-reduced-motion:reduce){.reports-submit-btn[data-v-438d904e]:hover{transform:none!important}}", ""]);

// exports
